module.exports = __webpack_public_path__ + "img/upload.ad4306db.svg";